require('./_wks-define')('asyncIterator');



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/es7.symbol.async-iterator.js
 ** module id = 293
 ** module chunks = 2 4 5 7
 **/